import { queryOptions, useMutation } from '@tanstack/react-query';
import { axiosGet, axiosPost } from '../utils/api';

export const getAllCompanies = ({ accessToken, params, config }) =>
  queryOptions({
    queryKey: ['/company', params],
    queryFn: async () => {
      const res = await axiosGet('/company', { params }, accessToken);
      return res.data;
    },
    ...config,
  });

export const useCreateCompany = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPost('/company', data);
    },
  });
